function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import * as actions from './actions';
var initialState = {
  loginUrl: '',
  logoutUrl: '',
  callbackId: 'unknown',
  hostBaseUrl: '',
  loginAlert: {
    isOpen: false,
    redirectUri: '',
    cancelUri: '',
    message: '',
    tag: ''
  }
};

var BlocketLoginHelperState = function BlocketLoginHelperState() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case actions.BLH_SET_CONFIG:
      return _objectSpread(_objectSpread({}, state), {}, {
        loginUrl: payload.loginUrl,
        logoutUrl: payload.logoutUrl,
        callbackId: payload.callbackId,
        hostBaseUrl: payload.hostBaseUrl
      });

    case actions.SHOW_LOGIN_TO_CONTINUE:
    case actions.CLOSE_LOGIN_TO_CONTINUE:
      return state.set('loginAlert', payload);

    default:
      return state;
  }
};

export default BlocketLoginHelperState;
//# sourceMappingURL=reducer.js.map